import { Component, OnInit } from '@angular/core';
import { AuthService } from '@app/services';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ErrorFormService } from '@app/services/error-form.service';
import { ActivatedRoute, Router } from '@angular/router';

@UntilDestroy()
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  changePasswordSuccess;
  changePasswordError;
  password;
  confirmPassword;
  showPassword = false;
  showPassword2 = false;
  hasError = false;
  resetPasswordToken: string = null;

  public get checkOneCapitalLetter() {
    return /[A-Z]/.test(this.password);
  }

  public get checkOneLowercaseLetter() {
    return /[a-z]/.test(this.password);
  }

  public get checkOneSpecialCharacter() {
    return /[#!?@$%^&*-]/.test(this.password);
  }

  public get checkOneDigit() {
    return /[0-9]/.test(this.password);
  }

  constructor(
    private authService: AuthService,
    private errorFormService: ErrorFormService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.changePasswordSuccess = false;
    this.changePasswordError = false;
    this.resetPasswordToken = this.route.snapshot.queryParamMap.get('state');
    this.verifyResetPasswordTokenValidity(this.resetPasswordToken);
  }

  resetPassword() {
    this.authService
      .resetPassword(this.password, this.confirmPassword, this.resetPasswordToken)
      .pipe(
        tap(() => {
          this.errorFormService.resetErrors();
          this.changePasswordSuccess = true;
        }),
        catchError((err) => {
          this.errorFormService.initErrors(err.error?.errors);
          return of(err);
        }),
        untilDestroyed(this),
      )
      .subscribe();
  }

  verifyResetPasswordTokenValidity(token) {
    if (!token) {
      this.router.navigate(['/']);
      return;
    }
    this.authService
      .verifyResetPasswordToken(token)
      .pipe(
        tap((res) => {
          if (res.success) {
            return true;
          }
          this.router.navigate(['/']);
        }),
        catchError(() => {
          this.router.navigate(['/']);
          return of(false);
        }),
        untilDestroyed(this),
      )
      .subscribe();
  }
}
